import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function WaitingPage({ header, assignedLabel, title = 'Točno ste odgovorili na sva pitanja.', message = 'Čekamo da i ostali natjecatelji završe.' }) {
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h5">{title}</Typography>
      <Typography>{message}</Typography>
    </PlayerCardLayout>
  );
}
